export default [
    {
        "id": "mainBanner-1",
        "plugin": null,
        "pluginId": null,
        "name": null,
        "html": require('./mainBanners/mainBanner-1/html').default,
        "scss": require('./mainBanners/mainBanner-1/scss').default,
        "scssTablet": require('./mainBanners/mainBanner-1/scssTablet').default,
        "scssMobile": require('./mainBanners/mainBanner-1/scssMobile').default,
        "css": require('./mainBanners/mainBanner-1/css').default,
        "cssTablet": require('./mainBanners/mainBanner-1/cssTablet').default,
        "cssMobile": require('./mainBanners/mainBanner-1/cssMobile').default,
        "js": require('./mainBanners/mainBanner-1/js').default,
        "minJs": require('./mainBanners/mainBanner-1/minJs').default,
        "settings": "",
        "svgContent": require('./mainBanners/mainBanner-1/svgContent').default,
        "svgViewBox": "0 0 1440 396",
        "svgContentMobile": require('./mainBanners/mainBanner-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 260"
    }
]